import { FC, HTMLAttributes, useState } from 'react';
import {
    ReturnToPlayerContainer,
    ReturnToPlayerDisplay,
    ReturnToPlayerText,
    RtpLabel,
    RtpPercentage,
} from './styled';

export type ReturnToPlayerProps = HTMLAttributes<HTMLDivElement> & {
    returnToPlayerValue: number;
};

export const ReturnToPlayer: FC<ReturnToPlayerProps> = ({
    returnToPlayerValue,
    ...props
}) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        setExpanded((prev) => !prev);
    };

    return (
        <ReturnToPlayerContainer data-exclude-from-paytable-close {...props}>
            <ReturnToPlayerDisplay
                $expanded={expanded}
                onClick={toggleExpanded}
            >
                <ReturnToPlayerText $expanded={expanded}>
                    <RtpLabel>RTP</RtpLabel>
                    {expanded && (
                        <>
                            :{' '}
                            <RtpPercentage>
                                {returnToPlayerValue}%
                            </RtpPercentage>
                        </>
                    )}
                </ReturnToPlayerText>
            </ReturnToPlayerDisplay>
        </ReturnToPlayerContainer>
    );
};
